<template>
    <Card>
      <AjaxForm v-if="user" :route="'admin/User/Edit/'+user._id">
      <label class="mr-3">نوع کاربر : </label>
      <div class="form-check-inline my-1">
        <div class="custom-control custom-radio">
          <input type="radio" id="person_type" v-model="user.person_type" value="person" name="person_type" class="custom-control-input">
          <label class="custom-control-label" for="person_type">حقیقی</label>
        </div>
      </div>
      <div class="form-check-inline my-1">
        <div class="custom-control custom-radio">
          <input type="radio" id="company_type" name="person_type" value="company" v-model="user.person_type" class="custom-control-input">
          <label class="custom-control-label" for="company_type">حقوقی</label>
        </div>
      </div>
      <hr/>
      <div v-if="user.person_type === 'person'">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-4">
            <CustomInput type="text" v-model="user.phone" name="phone" placeholder="تلفن همراه..." label="تلفن همراه"></CustomInput>
          </div>
          <div class="col-12 col-sm-12 col-md-4">
            <CustomInput type="text" v-model="user.f_name" label="نام" name="f_name" placeholder="نام"></CustomInput>
          </div>
          <div class="col-12 col-sm-12 col-md-4">
            <CustomInput type="text" v-model="user.l_name" label="نام خانوادگی" name="l_name" placeholder="نام خانوادگی"></CustomInput>
          </div>
          <div class="col-12 col-sm-12 col-md-4">
            <CustomInput type="text" label="کد ملی" v-model="user.national_code" name="national_code" placeholder="کد ملی..."></CustomInput>
          </div>
          <div class="col-12 col-sm-12 col-md-4">
            <CustomInput :not-select-append-to-body="(!!user_id)" placeholder="صنف کاری را انتخاب کنید" label="صنف کاری" name="guild_id[]" select-label="title" :select-options="select_guild_option"
                         :fetch-options="getGuildsForSelect"
                         :select_multiple="true"
                         v-model="user.guild_ids"
                         reduce_select="_id" type="select"></CustomInput>
          </div>
          <div class="col-12 col-sm-12 col-md-4">
            <CustomInput type="date" label="تاریخ تولد" v-model="user.birthdate" name="birthdate" placeholder="تاریخ تولد..."></CustomInput>
          </div>
          <div class="col-12 col-sm-12 col-md-4">
            <CustomInput type="text" label="تلفن ثابت" v-model="user.telephone" name="telephone" placeholder="تلفن ثابت..."></CustomInput>
          </div>
          <div class="col-12 col-sm-12 col-md-4">
            <CustomInput type="email" label="ایمیل" v-model="user.email" name="email" placeholder="ایمیل..."></CustomInput>
          </div>
          <div class="col-12 col-sm-12 col-md-4">
            <CustomInput type="textarea" label="آدرس محل زندگی" v-model="user.address_house" name="address_house" placeholder="آدرس محل زندگی..."></CustomInput>
          </div>
        </div>
        <h5 class="font-weight-bold text-center">اطلاعات تجاری</h5>
        <UserBusinessInformation :user="user" :user_id="user_id" :states="states" :cities="cities"></UserBusinessInformation>
        <h5 class="font-weight-bold text-center">تصاویر</h5>
        <div class="row">
          <div class="table-responsive">
            <table class="table table-bordered table-striped">
              <thead>
              <tr>
                <th style="width: 20%">عنوان</th>
                <th style="width: 45%">تصویر</th>
                <th style="width: 20%">وضعیت</th>
                <th style="width: 15%">ویرایش</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>کارت ملی</td>
                <td>
                  <div >
                    <div class="user_pic" v-if="!edit_national_pic">
                      <a v-if="user.national_card_pic" target="_blank" :href="storage_url+user.national_card_pic.name">
                        <img alt="" :src="storage_url+user.national_card_pic.name">
                      </a>
                    </div>
                    <div v-else class="upload-div">
                      <DragDropFileUpload name="national_card_pic" height="100"></DragDropFileUpload>
                    </div>
                  </div>
                </td>
                <td>
                  <CustomInput :not-select-append-to-body="(!!user_id)" :without-label="true" type="select" name="national_pic_status" :select-options="pic_statuses"
                  select-label="title"  placeholder="انتخاب وضعیت" v-model="national_pic_status" reduce_select="value"
                  ></CustomInput>
                </td>
                <td>
                  <button v-if="!edit_national_pic" type="button" class="btn btn-info" @click="edit_national_pic = !edit_national_pic">
                    ویرایش
                  </button>
                  <button v-else type="button" class="btn btn-danger" @click="edit_national_pic = !edit_national_pic">
                    کنسل
                  </button>
                </td>
              </tr>
              <tr>
                <td>پشت کارت ملی</td>
                <td>
                  <div >
                    <div class="user_pic" v-if="!edit_back_national">
                      <a v-if="user.back_national_card_pic" target="_blank" :href="storage_url+user.back_national_card_pic.name">
                        <img alt="" :src="storage_url+user.back_national_card_pic.name">
                      </a>
                    </div>
                    <div v-else class="upload-div">
                      <DragDropFileUpload name="back_national_card_pic" height="100"></DragDropFileUpload>
                    </div>
                  </div>
                </td>
                <td>
                  <CustomInput :not-select-append-to-body="(!!user_id)" type="select" name="back_card_status" :select-options="pic_statuses"
                               :without-label="true"
                               select-label="title"  placeholder="انتخاب وضعیت" v-model="back_card_status" reduce_select="value"
                  ></CustomInput>
                </td>
                <td>
                  <button v-if="!edit_back_national" type="button" class="btn btn-info" @click="edit_back_national = !edit_back_national">
                    ویرایش
                  </button>
                  <button v-else type="button" class="btn btn-danger" @click="edit_back_national = !edit_back_national">
                    کنسل
                  </button>
                </td>
              </tr>
              <tr>
                <td>جواز کسب</td>
                <td>
                  <div >
                    <div class="user_pic" v-if="!edit_p_javaz">
                      <a v-if="user.javaz_kasb_pic" target="_blank" :href="storage_url+user.javaz_kasb_pic.name">
                        <img alt="" :src="storage_url+user.javaz_kasb_pic.name">
                      </a>
                    </div>
                    <div v-else class="upload-div">
                      <DragDropFileUpload name="javaz_kasb_pic" height="100"></DragDropFileUpload>
                    </div>
                  </div>
                </td>
                <td>
                  <CustomInput :not-select-append-to-body="(!!user_id)" type="select" name="javaz_kasb_status" :select-options="pic_statuses"
                               :without-label="true"
                               select-label="title"  placeholder="انتخاب وضعیت" v-model="javaz_kasb_status" reduce_select="value"
                  ></CustomInput>
                </td>
                <td>
                  <button v-if="!edit_p_javaz" type="button" class="btn btn-info" @click="edit_p_javaz = !edit_p_javaz">
                    ویرایش
                  </button>
                  <button v-else type="button" class="btn btn-danger" @click="edit_p_javaz = !edit_p_javaz">
                    کنسل
                  </button>
                </td>
              </tr>
              </tbody>
            </table>
          </div></div>
      </div>
      <div v-if="user.person_type === 'company'">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-4">
            <CustomInput type="text" name="phone" v-model="user.phone" placeholder="تلفن همراه..." label="تلفن همراه"></CustomInput>
          </div>
          <div class="col-12 col-sm-12 col-md-4">
            <CustomInput type="text"  v-model="user.company_title" label="نام شرکت" name="company_title" placeholder="نام شرکت"></CustomInput>
          </div>
          <div class="col-12 col-sm-12 col-md-4">
            <CustomInput type="text"  v-model="user.ceo_fullname" label="مدیر عامل" name="ceo_fullname" placeholder="نام مدیرعامل"></CustomInput>
          </div>
          <div class="col-12 col-sm-12 col-md-4">
            <CustomInput placeholder="صنف کاری را انتخاب کنید"
                         label="صنف کاری" name="guild_id[]" select-label="title" :select-options="select_guild_option"
                         :fetch-options="getGuildsForSelect"
                         :select_multiple="true"
                         v-model="user.guild_ids"
                         :not-select-append-to-body="(!!user_id)"
                         reduce_select="_id" type="select"></CustomInput>
          </div>
          <div class="col-12 col-sm-12 col-md-4">
            <CustomInput type="text" v-model="user.national_id" name="national_id" label="شناسه ملی" placeholder="شناسه ملی..."></CustomInput>
          </div>
          <div class="col-12 col-sm-12 col-md-4">
            <CustomInput type="text" v-model="user.registration_number" name="registration_number" label="شماره ثبت" placeholder="شماره ثبت..."></CustomInput>
          </div>
          <div class="col-12 col-sm-12 col-md-4">
            <CustomInput type="text" v-model="user.economic_code" name="economic_code" label="کد اقتصادی" placeholder="کد اقتصادی..."></CustomInput>
          </div>
          <div class="col-12 col-sm-12 col-md-4">
            <CustomInput type="date" v-model="user.company_start_date"
                         name="company_start_date" label="تاریخ تأسیس" placeholder="تاریخ تأسیس..."></CustomInput>
          </div>
          <div class="col-12 col-sm-12 col-md-4">
            <CustomInput type="textarea" v-model="user.company_address" name="company_address" label="آدرس کامل شرکت" placeholder="آدرس کامل شرکت..."></CustomInput>
          </div>
          <div class="col-12 col-sm-12 col-md-4">
            <CustomInput type="email" name="email" v-model="user.email" label="ایمیل" placeholder="ایمیل..."></CustomInput>
          </div>
        </div>
        <h5 class="font-weight-bold text-center">اطلاعات تجاری</h5>
        <UserBusinessInformation :user="user" :user_id="user_id"></UserBusinessInformation>
        <h5 class="font-weight-bold text-center">تصاویر</h5>
        <div class="table-responsive">
          <table class="table table-bordered table-striped">
            <thead>
            <tr>
              <th style="width: 20%">عنوان</th>
              <th style="width: 45%">تصویر</th>
              <th style="width: 20%">وضعیت</th>
              <th style="width: 15%">ویرایش</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>آگهی تاسیس</td>
              <td>
                <div >
                  <div class="user_pic" v-if="!edit_agahi_tasis">
                    <a v-if="user.agahi_tasis_pic" target="_blank" :href="storage_url+user.agahi_tasis_pic.name">
                      <img alt="" :src="storage_url+user.agahi_tasis_pic.name">
                    </a>
                  </div>
                  <div v-else class="upload-div">
                    <DragDropFileUpload name="agahi_tasis_pic" height="100"></DragDropFileUpload>
                  </div>
                </div>
              </td>
              <td>
                <CustomInput :not-select-append-to-body="(!!user_id)" :without-label="true" type="select" name="agahi_tasis_status" :select-options="pic_statuses"
                             select-label="title"  placeholder="انتخاب وضعیت" v-model="agahi_tasis_status" reduce_select="value"
                ></CustomInput>
              </td>
              <td>
                <button v-if="!edit_agahi_tasis" type="button" class="btn btn-info" @click="edit_agahi_tasis = !edit_agahi_tasis">
                  ویرایش
                </button>
                <button v-else type="button" class="btn btn-danger" @click="edit_agahi_tasis = !edit_agahi_tasis">
                  کنسل
                </button>
              </td>
            </tr>
            <tr>
              <td>اساس نامه</td>
              <td>
                <div >
                  <div class="user_pic" v-if="!edit_asasname">
                    <a v-if="user.asasname_pic" target="_blank" :href="storage_url+user.asasname_pic.name">
                      <img alt="" :src="storage_url+user.asasname_pic.name">
                    </a>
                  </div>
                  <div v-else class="upload-div">
                    <DragDropFileUpload name="asasname_pic" height="100"></DragDropFileUpload>
                  </div>
                </div>
              </td>
              <td>
                <CustomInput :not-select-append-to-body="(!!user_id)" type="select" name="asasname_status" :select-options="pic_statuses"
                             :without-label="true"
                             select-label="title"  placeholder="انتخاب وضعیت" v-model="asasname_status" reduce_select="value"
                ></CustomInput>
              </td>
              <td>
                <button v-if="!edit_asasname" type="button" class="btn btn-info" @click="edit_asasname = !edit_asasname">
                  ویرایش
                </button>
                <button v-else type="button" class="btn btn-danger" @click="edit_asasname = !edit_asasname">
                  کنسل
                </button>
              </td>
            </tr>
            <tr>
              <td>روزنامه</td>
              <td>
                <div >
                  <div class="user_pic" v-if="!edit_newspaper">
                    <a v-if="user.newspaper_pic" target="_blank" :href="storage_url+user.newspaper_pic.name">
                      <img alt="" :src="storage_url+user.newspaper_pic.name">
                    </a>
                  </div>
                  <div v-else class="upload-div">
                    <DragDropFileUpload name="newspaper_pic" height="100"></DragDropFileUpload>
                  </div>
                </div>
              </td>
              <td>
                <CustomInput :not-select-append-to-body="(!!user_id)" type="select" name="newspaper_pic_status" :select-options="pic_statuses"
                             :without-label="true"
                             select-label="title"  placeholder="انتخاب وضعیت" v-model="newspaper_pic_status" reduce_select="value"
                ></CustomInput>
              </td>
              <td>
                <button v-if="!edit_newspaper" type="button" class="btn btn-info" @click="edit_newspaper = !edit_newspaper">
                  ویرایش
                </button>
                <button v-else type="button" class="btn btn-danger" @click="edit_newspaper = !edit_newspaper">
                  کنسل
                </button>
              </td>
            </tr>
            <tr>
              <td>آخرین تغییرات</td>
              <td>
                <div >
                  <div class="user_pic" v-if="!edit_last_change">
                    <a v-if="user.last_change_pic" target="_blank" :href="storage_url+user.last_change_pic.name">
                      <img alt="" :src="storage_url+user.last_change_pic.name">
                    </a>
                  </div>
                  <div v-else class="upload-div">
                    <DragDropFileUpload name="last_change_pic" height="100"></DragDropFileUpload>
                  </div>
                </div>
              </td>
              <td>
                <CustomInput :not-select-append-to-body="(!!user_id)" type="select" name="last_change_status" :select-options="pic_statuses"
                             :without-label="true"
                             select-label="title"  placeholder="انتخاب وضعیت" v-model="last_change_status" reduce_select="value"
                ></CustomInput>
              </td>
              <td>
                <button v-if="!edit_last_change" type="button" class="btn btn-info" @click="edit_last_change = !edit_last_change">
                  ویرایش
                </button>
                <button v-else type="button" class="btn btn-danger" @click="edit_last_change = !edit_last_change">
                  کنسل
                </button>
              </td>
            </tr>
            <tr>
              <td>جواز کسب</td>
              <td>
                <div >
                  <div class="user_pic" v-if="!edit_c_javaz">
                    <a v-if="user.javaz_kasb_pic" target="_blank" :href="storage_url+user.javaz_kasb_pic.name">
                      <img alt="" :src="storage_url+user.javaz_kasb_pic.name">
                    </a>
                  </div>
                  <div v-else class="upload-div">
                    <DragDropFileUpload name="javaz_kasb_pic" height="100"></DragDropFileUpload>
                  </div>
                </div>
              </td>
              <td>
                <CustomInput :not-select-append-to-body="(!!user_id)" type="select" name="javaz_kasb_status" :select-options="pic_statuses"
                             :without-label="true"
                             select-label="title"  placeholder="انتخاب وضعیت" v-model="c_javaz_kasb_status" reduce_select="value"
                ></CustomInput>
              </td>
              <td>
                <button v-if="!edit_c_javaz" type="button" class="btn btn-info" @click="edit_c_javaz = !edit_c_javaz">
                  ویرایش
                </button>
                <button v-else type="button" class="btn btn-danger" @click="edit_c_javaz = !edit_c_javaz">
                  کنسل
                </button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
        <div class="table-responsive">
          <table class="table table-bordered">
            <tr>
              <td>تصویر پروفایل</td>
              <td>
                <div >
                  <div class="user_pic" v-if="!edit_profile_pic">
                    <a v-if="user.profile_pic" target="_blank" :href="storage_url+user.profile_pic.name">
                      <img alt="" :src="storage_url+user.profile_pic.name">
                      <input type="hidden" name="profile_pic_name" readonly hidden :value="user.profile_pic.name">
                    </a>

                  </div>
                  <div v-else class="upload-div">
                    <DragDropFileUpload name="profile_pic" height="100"></DragDropFileUpload>
                  </div>
                </div>
              </td>
              <td class="col-12 col-md-3">
                <CustomInput type="select" name="profile_pic_status" :select-options="pic_statuses"
                             :not-select-append-to-body="(!!user_id)"
                             :without-label="true"
                             select-label="title"  placeholder="انتخاب وضعیت" v-model="profile_pic_status" reduce_select="value"
                ></CustomInput>
              </td>
              <td class="col-12 col-md-3">
                <button v-if="!edit_profile_pic" type="button" class="btn btn-info" @click="edit_profile_pic = !edit_profile_pic">
                  ویرایش
                </button>
                <button v-else type="button" class="btn btn-danger" @click="edit_profile_pic = !edit_profile_pic">
                  کنسل
                </button>
              </td>
            </tr>
            <tr>
              <td>تصویر کاور</td>
              <td>
                <div >
                  <div class="user_pic" v-if="!edit_cover_pic">
                    <a v-if="user.cover_pic" target="_blank" :href="storage_url+user.cover_pic.name">
                      <img alt="" :src="storage_url+user.cover_pic.name">
                      <input type="hidden" readonly hidden name="cover_pic_name" :value="user.cover_pic.name">
                    </a>
                  </div>
                  <div v-else class="upload-div">
                    <DragDropFileUpload name="cover_pic" height="100"></DragDropFileUpload>
                  </div>
                </div>
              </td>
              <td class="col-12 col-md-3">
                <CustomInput type="select" name="cover_status" :select-options="pic_statuses"
                             :not-select-append-to-body="(!!user_id)"
                             :without-label="true"
                             select-label="title"  placeholder="انتخاب وضعیت" v-model="cover_pic_status" reduce_select="value"
                ></CustomInput>
              </td>
              <td class="col-12 col-md-3">
                <button v-if="!edit_cover_pic" type="button" class="btn btn-info" @click="edit_cover_pic = !edit_cover_pic">
                  ویرایش
                </button>
                <button v-else type="button" class="btn btn-danger" @click="edit_cover_pic = !edit_cover_pic">
                  کنسل
                </button>
              </td>
            </tr>
            <tr>
              <td>تصویر پروفایل کسب وکار</td>
              <td>
                <div >
                  <div class="user_pic" v-if="!edit_business_pic">
                    <a v-if="user.business_pic" target="_blank" :href="storage_url+user.business_pic.name">
                      <img alt="" :src="storage_url+user.business_pic.name">
                      <input type="hidden" name="business_pic_name" hidden readonly :value="user.business_pic.name">
                    </a>
                  </div>
                  <div v-else class="upload-div">
                    <DragDropFileUpload name="business_pic" height="100"></DragDropFileUpload>
                  </div>
                </div>
              </td>
              <td class="col-12 col-md-3">
                <CustomInput type="select" name="business_pic_status" :select-options="pic_statuses"
                             :not-select-append-to-body="(!!user_id)"
                             :without-label="true"
                             select-label="title"  placeholder="انتخاب وضعیت" v-model="business_pic_status" reduce_select="value"
                ></CustomInput>
              </td>
              <td class="col-12 col-md-3">
                <button v-if="!edit_business_pic" type="button" class="btn btn-info" @click="edit_business_pic = !edit_business_pic">
                  ویرایش
                </button>
                <button v-else type="button" class="btn btn-danger" @click="edit_business_pic = !edit_business_pic">
                  کنسل
                </button>
              </td>
            </tr>
          </table>
        </div>
        <label>تصاویر گالری کاربر</label>
        <div  class="gallery-pics">
         <template v-if="user.gallery_pics && user.gallery_pics.length">
           <div v-for="(pic , index) in user.gallery_pics" :key="pic" class="gallery-pic-item">
             <button @click="deleteGalleryItem(index)" type="button" class="btn btn-danger btn-sm del-gallery-pic-btn"><i class="far fa-trash-can"></i></button>
             <img :src="storage_url+pic.name" alt="pic" class="">
             <input type="hidden" name="gallery_names[]" :value="pic.name" readonly>
             <select name="gallery_status[]" autocomplete="off" class="form-control mt-2" >
               <option disabled selected>انتخاب کنید</option>
               <option :selected="pic.status==='confirmed'" value="confirmed">تایید شده</option>
               <option :selected="pic.status==='denied'" value="denied">رد شده</option>
               <option :selected="pic.status==='waiting'" value="waiting">درانتظار تایید</option>
             </select>
           </div>
         </template>
          <div class="gallery-pic-select">
            <DragDropMultiFileUpload name="gallery_pics" title="افزودن تصویر جدید" height="100%"></DragDropMultiFileUpload>
          </div>
        </div>
        <div class="col-12 mb-3">
          <div class="h5 "><i class="far fa-map-pin"></i>&nbsp;موقعیت مکانی</div>
          <div class="" style="height:410px;">
            <div ref="map_div"></div>
          </div>
          <input type="hidden" readonly name="lat" v-if="user.lat" v-model="user.lat">
          <input type="hidden" readonly name="lng" v-if="user.lng" v-model="user.lng">
        </div>
      <hr/>
      <div class="row">
        <div class="col-12 col-sm-4">
          <CustomInput
              :not-select-append-to-body="(!!user_id)"
              v-model="user.customer_status" type="select" name="status" select-label="title" reduce_select="value" :select-options="status_options" label="وضعیت" placeholder="وضعیت را انتخاب کنید"></CustomInput>
        </div>
        <div class="col-12 col-md-4">
          <CustomInput :not-select-append-to-body="(!!user_id)" placeholder="معرف را انتخاب کنید" label="دعوت شده توسط" name="referral_user_id" select-label="title" :select-options="ref_users_option"
                       :fetch-options="getAllUsersForSelect"
                       v-model="user.ref_user"
                       reduce_select="_id" type="select"></CustomInput>
        </div>
        <div class="col-12 col-md-4">
          <CustomInput :not-select-append-to-body="(!!user_id)" placeholder="نمایش در اکسپلور" label="نمایش در اکسپلور" name="show_in_explore" select-label="title" :select-options="show_in_explore_options"
                       v-model="user.show_in_explore"
                       reduce_select="_id" type="select"></CustomInput>
        </div>
        <div class="col-12">
          <label>دلایل رد کردن کاربر : </label>
          <input type="hidden" name="deny_reason" v-model="user.deny_reason" hidden readonly >
          <editor v-model="user.deny_reason" api-key="f60dl4sz819mfm6cps7g9825ms3y9brgz2hlbiwc610e2mbd"
                  :init="{
                     language: 'fa',
                     directionality : 'rtl',
                     menubar: false,
                     toolbar:
                     'undo redo | formatselect | bold italic backcolor | \
                     alignright aligncenter alignleft alignjustify | \
                     bullist numlist outdent indent | removeformat'}"
          ></editor>
        </div>
      </div>
      <div class="row">
        <div class="col-10 col-sm-8 col-md-5 mx-auto mt-3">
          <button class="btn btn-info btn-block" type="submit">ذخیره اطلاعات کاربر</button>
        </div>
      </div>
      </AjaxForm>
      <div v-if="error" class="alert alert-danger">{{error}}</div>
    </Card>
</template>

<script>
import Card from "@/components/forms/Card";
import CustomInput from "@/components/CustomInput";
import {AppApi} from "@/api/AppApi";
import {ProductApi} from "@/api/ProductApi";
import AjaxForm from "@/components/forms/AjaxForm";
import {mapActions, mapGetters} from "vuex";
import {UserApi} from "@/api/UserApi";
import DragDropFileUpload from "@/components/DragDropFileUpload";
import {dateInput, searchInObjArray} from "@/shared/helper";
import Editor from '@tinymce/tinymce-vue'
import DragDropMultiFileUpload from "@/components/DragDropMultiFileUpload.vue";
import UserBusinessInformation from "@/components/UserBusinessInformation.vue";
import "leaflet/dist/leaflet.css";
// import { LMap, LTileLayer,LMarker} from "@vue-leaflet/vue-leaflet";
import L from 'leaflet'
import 'leaflet-geosearch/dist/geosearch.css';
import {GeoSearchControl, OpenStreetMapProvider} from 'leaflet-geosearch';

export default {
name: "UserEdit",
  components:{
    UserBusinessInformation,
    DragDropMultiFileUpload, AjaxForm, CustomInput, Card,DragDropFileUpload,Editor},
  props : ['user_id'],
  data()
  {
    return{
      centerMap : [35.430012, 51.240000],zoom:12,
      marker : null,
      cats_options : [],
      brand_options : [],
      ref_users_option : [],
      edit_national_pic : false,
      edit_back_national : false,
      edit_p_javaz : false,
      edit_c_javaz : false,
      edit_agahi_tasis : false,
      edit_newspaper : false,
      edit_profile_pic : false,
      edit_business_pic : false,
      edit_cover_pic : false,
      edit_asasname : false,
      edit_last_change : false,
      person_type : null,
      error:null,
      user:null,
      states:[],
      cities : [],
      select_guild_option : [],
      guild:[],
      status:null,
      first_init : true,
      storage_url : '',
      id : this.$route.params.id,
      pic_statuses :[{value : 'waiting',title : 'درانتظار بررسی'},
        {value : 'confirmed',title : 'تایید شده'},
        {value : 'denied',title : 'رد شده'}
      ],
      national_pic_status: null,back_card_status: null,javaz_kasb_status: null,profile_pic_status: null,business_pic_status: null,
      last_change_status : null,agahi_tasis_status : null,asasname_status : null,
      newspaper_pic_status : null,c_javaz_kasb_status : null,cover_pic_status:null,
      status_options:[{value : 'waiting',title : 'در انتظار بررسی'},{value : 'confirmed',title : 'تایید شده'},{value : 'denied',title : 'رد شده'}],
      show_in_explore_options:[{_id : '1',title : 'داشتن پلن خریداری شده'},{_id : '2',title : 'نمایش'},{_id : '3',title : 'عدم نمایش'}],
      map : null,
      lMarker: null,
      lat:null,lng:null,
    }
  },
  async mounted()
  {
    if (!this.user_id)
    {
      this.setPageTitle('ویرایش اطلاعات کاربر');
      this.setShowHead(true);
    }
    const self = this;
    this.initPage();
     AppApi.getStates().then(result=>{
       self.states = result;
    });
  },
  methods:{
    ...mapActions('app',{
      setPageTitle:'setPageTitle',
      setPageLoading:'setPageLoading',
      setShowHead : 'setShowHead'
    }),
    initMap() {
      this.map = null;

      this.$refs.map_div.innerHTML = '<div style="height:400px; width:100%" id="map2"></div>';
      setTimeout(() => {
        this.map = L.map('map2').setView(this.centerMap, this.zoom);

        L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {}).addTo(this.map);
        const img = require('./../../assets/marker-icon.png')
        const myIcon = L.icon({
          iconUrl: img,
          iconSize: [25, 41],
          iconAnchor: [18, 41],
        });

        const map = this.map;
        const search = new GeoSearchControl({
          provider: new OpenStreetMapProvider(),
          style: 'bar',
          marker: false,
          placeholder: 'Search for Location'
        });

        map.addControl(search);
        if (this.user.lat && this.user.lng)
        {
          this.marker = new L.marker({lat : this.user.lat,lng : this.user.lng},{icon : myIcon}).addTo(map);
        }


        this.map.on('click', (e) => {
          if (this.marker)
            map.removeLayer(this.marker)
          this.marker = new L.marker(e.latlng,{icon : myIcon}).addTo(map);
          this.user.lat = e.latlng.lat;
          this.user.lng = e.latlng.lng;

        });
        document.querySelector('input.glass').placeholder = "جستجو آدرس(شهرو منطقه)";
      }, 500);
    },
    deleteGalleryItem(index)
    {
      this.user.gallery_pics.splice(index,1);
    },
    async fetchProductCategories(text,loading)
    {
      loading(true);
      if (text && text.length)
      {
        const result = await AppApi.getProductCategoriesForSelectAjax(text,this.user.guild_ids);
        if (result)
        {
          this.cats_options = result.categories;
        }
        else
          this.cats_options = [];
      }
      loading(false);
    },
    async fetchProductBrands(text,loading)
    {
      loading(true);
      if (text && text.length)
      {
        const result = await AppApi.getProductBrandForSelectAjax(text,this.user.guild_ids);
        if (result)
        {
          this.brand_options = result.brands;
        }
        else
          this.brand_options = [];
      }
      loading(false);
    },
    addMarker(e)
    {
      this.marker = e.latlng;
    },
    async initPage(){
      // this.setPageLoading(true);
      this.id = this.$route.params.id;
      if (!this.id)
        this.id = this.user_id;
      this.user = null;
      this.error = null;
      const result = await UserApi.getUserInfoForEdit(this.id);
      if (result.ok)
      {

        this.user = result.user;
        if (this.user.lat && this.user.lng)
        {
          this.centerMap = [this.user.lat, this.user.lng]
          this.marker = {lat: this.user.lat, lng: this.user.lng}
        }
        this.storage_url = process.env.VUE_APP_API_URL + process.env.VUE_APP_USER_STORAGE;
        this.national_pic_status = this.getSelectStatus(this.user.national_card_pic ? this.user.national_card_pic.status : null)
        this.back_card_status = this.getSelectStatus(this.user.back_national_card_pic ? this.user.back_national_card_pic.status : null)
        this.javaz_kasb_status = this.getSelectStatus(this.user.javaz_kasb_pic ? this.user.javaz_kasb_pic.status : null)
        this.profile_pic_status = this.getSelectStatus(this.user.profile_pic ? this.user.profile_pic.status : null)
        this.business_pic_status = this.getSelectStatus(this.user.business_pic ? this.user.business_pic.status : null)
        this.c_javaz_kasb_status = this.getSelectStatus(this.user.javaz_kasb_pic ? this.user.javaz_kasb_pic.status : null)
        this.cover_pic_status = this.getSelectStatus(this.user.cover_pic ? this.user.cover_pic.status : null)
        this.last_change_status = this.getSelectStatus(this.user.last_change_pic ? this.user.last_change_pic.status : null)
        this.agahi_tasis_status = this.getSelectStatus(this.user.agahi_tasis_pic ? this.user.agahi_tasis_pic.status : null)
        this.asasname_status = this.getSelectStatus(this.user.asasname_pic ? this.user.asasname_pic.status : null)
        this.newspaper_pic_status = this.getSelectStatus(this.user.newspaper_pic ? this.user.newspaper_pic.status : null)
        if (this.user.customer_status)
        {
          const index = searchInObjArray(this.user.customer_status, this.status_options, 'value', true);
          if (index !== false)
          {
            this.user.customer_status = this.status_options[index];
          }
        }
        if (this.user.show_in_explore)
        {
          const index = searchInObjArray(this.user.show_in_explore, this.show_in_explore_options, '_id', true);
          if (index !== false)
          {
            this.user.show_in_explore = this.show_in_explore_options[index];
          }
        }
        if (this.user.birthdate)
        {
          this.user.birthdate = dateInput(this.user.birthdate);
        }
        if (this.user.company_start_date)
        {
          this.user.company_start_date = dateInput(this.user.company_start_date);
        }
        setTimeout(()=>{
          this.initMap()
        },1000)
      }
      else
      {
        this.error = result.error;
      }
      this.setPageLoading(false);
    },
    getCitiesByStateId()
    {
      AppApi.getCitiesByStateId(this.user.state_id._id).then(result=>{
        if (!this.first_init)
          this.user.city_id = null;
        else
          this.first_init = false;
        this.cities = result;
      })
    },
    async getAllUsersForSelect(search,loading)
    {
      loading(true);
      if (search.length > 1)
      {
        const data = await ProductApi.getAllUsersForSelect(search);
        if (data.ok)
        {
          this.ref_users_option = data.users;
        }
        else
          this.ref_users_option = [];
      }
      loading(false);
    },
    async getGuildsForSelect(search,loading)
    {
      loading(true);
      if (search.length > 1)
      {
        const data = await ProductApi.getGuildForSelectAjax(search);
        if (data.ok)
        {
          this.select_guild_option = data.guilds;
        }
        else
          this.select_guild_option = [];
      }
      loading(false);
    },
    getSelectStatus(status)
    {
      if (!status)
        return null;
      const index = searchInObjArray(status,this.pic_statuses,'value',true);
      if (index !== false)
        return this.pic_statuses[index];
      return null;
    }
  },
  watch:{
    'user.state_id':{
    handler(s)
    {
      if (s)
      {
        this.getCitiesByStateId();
      }
      else
      {
        this.user.state_id = null;
        this.user.city_id = null;
      }
    }
  }
  },
}
</script>

<style scoped>
.user_pic img
{
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.user_pic
{
  width: 120px;
  height: 120px;
}
.upload-div
{
  max-width: 300px;
}
.gallery-pics
{
  display: flex;
  justify-content: flex-start;
  grid-gap: 10px;
  flex-wrap: wrap;
  align-items: center;
}
.gallery-pic-item
{
  flex: 0 0 150px;
  width: 150px;
  box-shadow: 0 0 3px 1px #0000004C;
  border-radius: 10px;
  overflow: hidden;
  position: relative;
}
.gallery-pic-select
{
  flex: 0 0 300px;
}
.gallery-pic-item img
{
  width: 150px;
  height: 150px;
  object-fit: contain;
}
.del-gallery-pic-btn
{
  position: absolute;
  left: 0;
  top: 0;
}
</style>